import { Helmet } from 'react-helmet-async';
import '../assets/styles/AboutUs.css'
import teamImg from "../assets/images/main_banner.png";
import missionImg from "../assets/images/frontend.jpeg";
import visionImg from "../assets/images/mobileappdevelopment.png";


const About = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> About Us – BuddyTech Solutions </title>
        <meta name="description" content="Learn how BuddyTech empowers businesses with smart tech, flexible work, and transparent systems." />
        <meta name="keywords" content="about BuddyTech, company mission, team" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="About Us – BuddyTech Solutions" />
        <meta property="og:description" content="Learn how BuddyTech empowers businesses with smart tech, flexible work, and transparent systems." />
        <meta property="og:keywords" content="about BuddyTech, company mission, team" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/about" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Us – BuddyTech Solutions" />
        <meta name="twitter:description" content="Learn how BuddyTech empowers businesses with smart tech, flexible work, and transparent systems." />
        <meta name="twitter:keywords" content="about BuddyTech, company mission, team" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
 </Helmet>
       <div className="about-wrapper">
      <header className="about-hero">
        <h1>About BuddyTechSolutions</h1>
        <p>
          We’re a tech-driven innovation company committed to excellence in IT services,
          design, MIS, and construction planning since 2025.
        </p>
      </header>

      <section className="about-intro">
        <div className="about-text">
          <h2>Who We Are</h2>
          <p>
            BuddyTechSolutions is a multidisciplinary company based in [Your City/Country],
            delivering expert services in software development, UI/UX and graphic design,
            MIS execution, and construction planning & estimation including AriTech solutions.
          </p>
        </div>
        <img src={teamImg} alt="Our Team" className="about-img" />
      </section>

      <section className="about-core">
        <img src={missionImg} alt="Mission" className="about-img" />
        <div className="about-text">
          <h2>Our Mission</h2>
          <p>
            To build digital and physical infrastructure that simplifies workflows,
            enhances productivity, and transforms businesses with innovation and precision.
          </p>
        </div>
      </section>

      <section className="about-core reverse">
        <div className="about-text">
          <h2>Our Vision</h2>
          <p>
            To be a globally trusted brand in technology and construction services,
            recognized for innovation, integrity, and impact.
          </p>
        </div>
        <img src={visionImg} alt="Vision" className="about-img" />
      </section>

      <section className="about-values">
        <h2>Core Values</h2>
        <ul>
          <li>Innovation & Excellence</li>
          <li>Client-Centric Service</li>
          <li>Integrity & Transparency</li>
          <li>Team Collaboration</li>
          <li>Flexibility & Professional Growth</li>
        </ul>
      </section>

      <section className="about-culture">
        <h2>Work Culture</h2>
        <ul>
          <li>Flexible working hours</li>
          <li>Transparent payment system</li>
          <li>Consistent, high-quality projects</li>
          <li>Supportive professional community</li>
        </ul>
      </section>

      <section className="about-team">
        <h2>Team & Achievements</h2>
        <p>
          Our passionate team of developers, designers, engineers, and MIS professionals
          have successfully delivered impactful solutions to clients worldwide.
        </p>
      </section>
    </div>
    </>
  );
};

export default About;
